{
	"accountsPayable": "Factures à payer",
	"accountsReceivable": "Factures à recevoir",
	"costCenter": "Centre de coûts",
	"planAccounts": "Plan comptable",
	"providers": "Gestion des partenaires",
	"checkingAccounts": "Compte Courant",
	"reports": "Rapports",
	"cashflow": "Des flux de trésorerie",
	"finExManagerialReport": "DRE",
	"noticeIsFreeModule": "Module gratuit jusqu'à",
	"conciliation": "Conciliation via OFX",
	"bankAccounts": "Cuentas bancarias",
	"eventConference": "Conférence d'événements"
}
